// export const BoxType = 'hg'
// export const BoxType = '05'
// export const BoxType = '01'
export const BoxType = 'hz'
export default function BoxColor() {
  if (BoxType == 'hg'){
    return '#00CDC6'
  }else if (BoxType == '05'){
    return '#0096FB'
  }else if (BoxType == '01'){
    return '#E73B25'
  }else if (BoxType == 'hz'){
    return '#eb424c'
  }
}